import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import ReCAPTCHA from 'react-google-recaptcha';
import { Form, LocalTheme } from 'ecrion-components';
import { sendResetPasswordEmail } from '../../utils/portalPasswordsClient';
import useRecaptcha from './useRecaptcha';

const customTheme = {
  overrides:{
    MuiButton: {
      root: {
        backgroundColor: '#FF6633',
        color: 'white',
        '&:focus': {
          backgroundColor: '#FF6633',
          color: 'white'
        },
        '&:hover':{
          backgroundColor: '#FF9933',
          color: 'white'
        },
        '&.Mui-disabled':{
          color: 'white !important'
        }
      }
    }
  }
}

const ForgottenPasswordForm = ({ onClose, environment }) => {
  const { recaptcha, error } = useRecaptcha();
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [state, setState] = useState({sent: false, email: null});

  const onChange = (e) => {
    setRecaptchaValue(e);
  };

  return (
    <> 
      {!state.sent ? (        
        <Form.Dialog
          onCancel={onClose}
          submitAlign="right"
          submitLabel={'Send'}
          submittingLabel={'Sending...'}
          onValidate={() => {
            const errors = {};
            if (recaptcha && recaptcha.Enabled && !recaptchaValue) {
              errors.recaptcha = 'Please verify that you are a Human.';
            }
            return errors;
          }}
          onSuccess={(data) => {
            return sendResetPasswordEmail(
              data.username,
              environment ? environment : data.environment,
              recaptchaValue
            ).then(() => {
              setState({sent: true, email: data.username});
            });
          }}
          windowProps={{
            header: 'Forgot Password',
            style: { width: 600 },
          }}
          renderContent={() => (
            <React.Fragment>
              <Typography variant="body2">
                Enter your username (and environment if required) to reset the
                password.
              </Typography>
              <Form.Fields.Text required name="username" label="Username" variant="outlined"/>
              {!environment && (
                <Form.Fields.Text
                  required
                  name="environment"
                  label="Environment"
                  variant="outlined"
                />
              )}
              {error ? (
                <Typography color="error">
                  Couldn't retrieve recaptcha settings, please contact customer
                  support.
                </Typography>
              ) : (
                <>
                  {recaptcha && recaptcha.Enabled && (
                    <ReCAPTCHA
                      onChange={(e) => onChange(e)}
                      align="center"
                      sitekey={recaptcha.SiteKey}
                    />
                  )}
                </>
              )}
            </React.Fragment>
          )}
        />
        
      ) : (
        <Form.Dialog
          hideCancelButton
          submitAlign="right"
          submitLabel={'Ok'}
          onSuccess={onClose}
          windowProps={{
            header: 'Email Sent',
            style: { width: 600 },
          }}
          renderContent={() => (
            <React.Fragment>
              <Typography variant="body2" color="primary">
                We've sent an email with a link to finish resetting your password at:
              </Typography>
              <Typography>
                <b>{state.email}</b>
              </Typography>
            </React.Fragment>
          )}
        />
      )}    
    </>    
  );
};

export default ForgottenPasswordForm;
